<!-- Scrim: click to close -->
<div class="notif-scrim" [class.show]="toggleStyle" (click)="closeAddItemSidebar($event)"></div>

<aside class="notif-drawer" [class.show]="toggleStyle" role="dialog" aria-label="Notifications">
  <!-- Header -->
  <header class="notif-head">
    <div class="notif-head-top">
      <h2>
        Notifications
        <span class="notif-count" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
      </h2>
      <button type="button" class="notif-close" (click)="closeAddItemSidebar($event)" aria-label="Close notifications"
              tooltip="Close" placement="bottom" container="body" containerClass="srd-tip-bubble notif-tip-bubble">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
             stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
      </button>
    </div>
  </header>

  <!-- Tabs, filters, rows and Load more. -->
  <app-notification-feed (navigated)="closeAddItemSidebar()"
                         (unreadTotalChange)="onUnreadTotal($event)"></app-notification-feed>

  <footer class="notif-foot">
    <button type="button" class="notif-viewall" (click)="seeAllNotifications()">
      View all notifications
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
           stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
    </button>
  </footer>
</aside>
